import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { AudioMessage } from "@/store/chats/types";
import AudioPlayer from "../AudioPlayer/AudioPlayer.vue";
import { useAudioPlayer } from "../AudioPlayer";
import { computed } from "vue";

interface ChatMessageProps {
  message: AudioMessage;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioMessagePlayer',
  props: {
    message: {}
  },
  setup(__props: any) {

const props = __props;
const audioAttachment = computed(() => props.message.attachments?.[0]);

const { audioPlayerProps } = useAudioPlayer({
  isRecorder: false,
  isMine: props.message.isMine,
  containerId: `player_${props.message.id}`,
  url: audioAttachment.value?.url,
  duration: audioAttachment.value?.duration,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AudioPlayer, _normalizeProps(_guardReactiveProps(_unref(audioPlayerProps))), null, 16))
}
}

})